import React from 'react';

const SvgCloseSmall = props => (
  <svg
    width={8}
    height={8}
    viewBox="0 0 8 8"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      d="M4 2.671L6.525.147a.501.501 0 0 1 .708 0l.62.62a.501.501 0 0 1 0 .708L5.33 4l2.524 2.525a.501.501 0 0 1 0 .708l-.62.62a.501.501 0 0 1-.708 0L4 5.33 1.475 7.853a.501.501 0 0 1-.708 0l-.62-.62a.501.501 0 0 1 0-.708L2.67 4 .147 1.475a.501.501 0 0 1 0-.708l.62-.62a.501.501 0 0 1 .708 0L4 2.67z"
      fill="#F9F9F9"
      fillRule="evenodd"
    />
  </svg>
);

export default SvgCloseSmall;
